module.exports = __webpack_public_path__ + "static/media/Dev Flow.9e938632.png";